import { Component, OnInit, OnDestroy, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Subscription } from 'rxjs';
import { Rubric, EngineRubricSkill } from '@mira-avant/mtlibs';
import { CommonModule } from '@angular/common';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzTypographyModule } from 'ng-zorro-antd/typography';
import { RouterModule } from '@angular/router';
import { EngineService } from '../../../../services/engine.service';
import { ZorroModule } from '../../../../modules/zorro.module';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';

@Component({
	selector: 'app-engine-rubric-skill-table',
	standalone: true,
	imports: [CommonModule, NzTableModule, NzButtonModule, NzTypographyModule, RouterModule, ZorroModule],
	templateUrl: './engine-rubric-skill-table.component.html',
	styleUrl: './engine-rubric-skill-table.component.scss',
})
export class EngineRubricSkillTableComponent implements OnInit, OnDestroy, OnChanges {
	@Input('rubric') public rubric: Rubric | undefined | null;
	public engineRubricSkills: EngineRubricSkill[] = [];
	private subscriptions: Subscription = new Subscription();

	constructor(public engineService: EngineService) {}

	ngOnInit(): void {
		// Subscribe to EngineRubricSkill entries
		this.subscriptions.add(
			this.engineService.engineRubricSkills$.subscribe(engineRubricSkills => {
				if (this.rubric?.code) {
					this.engineRubricSkills = engineRubricSkills.filter(
						engineRubricSkill => this.rubric && engineRubricSkill.rubric_code === this.rubric.code
					);
				} else {
					this.engineRubricSkills = [];
				}
			})
		);
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes['rubric'] && this.rubric?.code) {
			// Fetch EngineRubricSkill entries when rubric changes
			this.engineService.getEngineRubricSkills$(undefined, this.rubric.code).catch(error => {
				console.warn('No EngineRubricSkill entries found:', error);
				this.engineRubricSkills = [];
			});
		} else if (changes['rubric'] && !this.rubric?.code) {
			this.engineRubricSkills = [];
		}
	}

	public async deleteEngineRubricSkill(uuid: string): Promise<void> {
		try {
			await this.engineService.deleteEngineRubricSkill$(uuid);
		} catch (error) {
			console.error('Error deleting EngineRubricSkill:', error);
		}
	}

	public selectEngineRubricSkill(engineRubricSkill: EngineRubricSkill | undefined): void {
		this.engineService.selectEngineRubricSkill(engineRubricSkill);
	}

	ngOnDestroy(): void {
		this.subscriptions.unsubscribe();
	}
}
